var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { class: _vm.mergedClass, style: _vm.mergedStyle }, [
    _vm._v(_vm._s(_vm.title))
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }